module.exports = __webpack_public_path__ + "img/armhole binding width.c3acfeb1.png";